import FacebookIcon from './facebook-icon.svg';

export default FacebookIcon;
